// src/MsalProviderWrapper.js
import React, { useState, useEffect } from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

const MsalProviderWrapper = ({ children }) => {
  const [msalInstance, setMsalInstance] = useState(null);

  useEffect(() => {
    const instance = new PublicClientApplication(msalConfig);
    setMsalInstance(instance);
  }, []);

  // While waiting for the instance to be created, you might return null or a loader.
  if (!msalInstance) return null;

  // After creating your msalInstance:
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }


  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MsalProviderWrapper;
